import { render, staticRenderFns } from "./dwd-phase-2.vue?vue&type=template&id=5d3a00ad&"
import script from "./dwd-phase-2.vue?vue&type=script&lang=js&"
export * from "./dwd-phase-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports